module.exports = __webpack_public_path__ + "img/bannerQF.d8f11415.png";